export const stopEventPropagation = (e) => e.stopPropagation();

export const copyToClipboard = (text) => navigator.clipboard.writeText(text);
